import { apiClient } from '@/services/ApiClient.js'

export default {
  getCategories(query) {
    return apiClient
      .get('categories', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCategory(id) {
    return apiClient
      .get('categories/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editCategory(id, category) {
    return apiClient
      .patch('categories/' + id, category)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createCategory(category) {
    return apiClient
      .post('categories', category)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteCategory(id) {
    return apiClient
      .delete('categories/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBrands(id) {
    return apiClient
      .get('categories/' + id + '/brands')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  attachBrand(categoryId, brandIds) {
    return apiClient
      .post('categories/' + categoryId + '/brands', {
        brands: JSON.stringify(brandIds)
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removeBrand(categoryId, brandId) {
    return apiClient
      .delete('categories/' + categoryId + '/brands/' + brandId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
